import { render, staticRenderFns } from "./Selected.vue?vue&type=template&id=2612e3b3"
import script from "./Selected.vue?vue&type=script&lang=js"
export * from "./Selected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports